import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class NationalityService {
    constructor(private apiHttp: ApiHttp) {
    }

    public getIsActiveNationalities(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/Nationality/GetIsActiveNationalities', data, messageService);
    }
}
